define('GameDayCore/GDModel/ValueObjects/HotColdZone/HotColdZones',['require','exports','module','../ValueObjectFactory','./HotColdSitFile'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		HotColdSitFile = require('./HotColdSitFile');
	VO.create(HotColdZones);

	function HotColdZones($data, $paramObj) {
		var vo = VO.ensureVO(this, HotColdZones),
			data = $data,
			paramObj = $paramObj;

		vo.sitModel = new HotColdSitFile(data.sit, paramObj.playerType === "p");
		vo.sitID = paramObj.sit || "";
		vo.playerID = paramObj.id || "";
		vo.playerType = paramObj.playertype || "";
		vo.num = data.num || "";
		vo.ab = data.ab || "";
		vo.avg = data.avg || "";
		vo.hr = data.hr || "";
		vo.rbi = data.rbi || "";
		vo.bb = data.bb || "";
		vo.so = data.so || "";
		vo.ops = data.ops || "";
	}

	return HotColdZones;
});
